export const SIDE_BAR_TAB_INDEX = 'sideBarTabIndex';
export const IS_SIDEBAR_EXPANDED = 'isSideBarExpanded';
